/**
 * Created by Jan Bradac on 7.5.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.FlashMessages;

    (function (FlashMessages, $, undefined) {
        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * TODO write object documentation here
         * @memberOf Lfl.FlashMessages
         */
        Lfl.FlashMessages.Hider;

        (function (Hider, $, undefined) {
            /*
             |===========================================================================================================
             | Object definition
             |===========================================================================================================
             */


            var VISIBLE_PIXELS_WHEN_HIDDEN = 7;
            var ON_HOVER_VISIBLE_PIXELS_WHEN_HIDDEN = 15;
            var HIDDEN_CLASS = 'flash-message-hidden';
            /**
             * Time in milliseconds that the on hover animation takes.
             * @type {number}
             */
            var TIME_TO_PEEK_OUT = 100;

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             *
             * @memberOf Lfl.FlashMessages.Hider
             * @param messageId The id of the message
             * @param [delay] Flash message autohide delay in milliseconds
             */
            Hider.autohide = function (messageId, delay) {
                $(document).ready(
                    function () {
                        setTimeout(function () {
                            Hider.hide(messageId, delay);
                        }, delay);
                    });
            };


            /**
             *
             * @memberOf Lfl.FlashMessages.Hider
             * @param messageId The id of the message
             */
            Hider.hide = function (messageId) {
                var $message = $('#' + messageId);
                $message.off();


                $message.velocity({"right": VISIBLE_PIXELS_WHEN_HIDDEN - $message.outerWidth()}, {easing: [.44,1.42,.42,.83], duration: 600});
                $message.addClass(HIDDEN_CLASS);


                setTimeout(function () {
                    $message.on({
                        click: function () {
                            if ($message.hasClass(HIDDEN_CLASS)) {
                                $message.removeClass(HIDDEN_CLASS);
                                $message.velocity({"right": 0});
                            }
                        },

                        mouseenter: function () {
                            if ($message.hasClass(HIDDEN_CLASS)) {
                                $message.velocity({"right": ON_HOVER_VISIBLE_PIXELS_WHEN_HIDDEN - $message.outerWidth()}, {duration: TIME_TO_PEEK_OUT, easing: "ease"})
                            }
                        },
                        mouseleave: function () {
                            if ($message.hasClass(HIDDEN_CLASS)) {
                                $message.velocity({"right": VISIBLE_PIXELS_WHEN_HIDDEN - $message.outerWidth()}, {duration: TIME_TO_PEEK_OUT, easing: "ease"})
                            }
                        }
                    });
                }, 200);

            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */
        }(FlashMessages.Hider = FlashMessages.Hider || {}, jQuery));
    }(Lfl.FlashMessages = Lfl.FlashMessages || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
